import { Component, ElementRef, EventEmitter, Input, Output, ViewChild, forwardRef } from '@angular/core';
import { FormControl, NG_VALUE_ACCESSOR } from '@angular/forms';
import { CdkScrollable, ScrollDispatcher } from '@angular/cdk/scrolling';
import { MatAutocomplete, MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { IOption } from '../../../base/models/option';

@Component({
  selector: 'dexio-autocomplete',
  templateUrl: './autocomplete.component.html',
  styleUrl: './autocomplete.component.scss',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => AutocompleteComponent),
      multi: true
    }
  ]
})
export class AutocompleteComponent {
  @ViewChild('input') input: ElementRef<HTMLInputElement> = {} as ElementRef<HTMLInputElement>;
  @ViewChild('input', { read: MatAutocompleteTrigger }) autocompleteTrigger: MatAutocompleteTrigger | null = null;
  @ViewChild(MatAutocomplete) autocomplete: MatAutocomplete | null = null;
  @Input() id: string = 'autocomplete';
  @Input() options: Array<IOption> = [];
  
  private _option:  IOption | undefined;
  get option():  IOption | undefined {
    return this._option;
  }
  @Input() set option(value: IOption | string) {
    if (typeof(value) == 'string') {
      if (value && value != '') {
        value = this.options.find(_ => _.value == value) ?? this.options.find(_ => _.display == value) ?? '';
      }
    }
    if ((!this.option && !value) || (this._option?.value == (value as IOption|undefined)?.value)) { return; }
    this._option = (value as IOption|undefined);
    this.control.setValue((value=='')?null:value);
    this.optionChange.emit((value == '')?null:(value as IOption));
  }
  @Output() optionChange:EventEmitter<IOption|null> = new EventEmitter<IOption|null>();
  
  control = new FormControl<string | IOption>('');
  filteredOptions: Array<IOption> = [];

  constructor(private readonly scroll: ScrollDispatcher){
    this.filteredOptions = this.options.slice();
    this.scroll.scrolled().subscribe((data: void | CdkScrollable) => {
      this.onScroll(data);
    });
  }  
  
  displayFn(option: IOption): string {
    return option && option.value != '' ? option.display : '';
  }

  filter() {
    this.filteredOptions = this._filter(this.input.nativeElement.value);
  }
  onSelectOption(option: any) {
    this.autocomplete?._keyManager.setActiveItem(option.option);
    this.option = option.option.value;
    this.control.setValue(option.option.value);
    this.filteredOptions = this._filter(option.option.value.value);
    option._selectViaInteraction();
  }
  onTextChange($event: any) {
    if ($event.target.value == '') { this.option = ''; return; }
    const options = this._filter($event.target.value);
    if (options.length == 1) { 
      this.option = options[0];
      this.control.setValue(options[0]);
      this.autocomplete?._keyManager.setActiveItem((options[0] as any));
    }
  }
  onKeydown($event: KeyboardEvent) {
    if ($event.code == 'Tab') {
      if (($event.target as any).value != '') {
        this.option = this.autocomplete?._keyManager.activeItem?.value;
        this.control.setValue(this.autocomplete?._keyManager.activeItem?.value);
        this.filteredOptions = this._filter(this.autocomplete?._keyManager.activeItem?.value.value);
        this.autocomplete?.options.find(_ => _.value == this.autocomplete?._keyManager.activeItem?.value.value)?._selectViaInteraction();
      } else {
        this.option = '';
        this.control.setValue(null);
      }
    } else if ($event.code == 'ArrowUp' || $event.code == 'ArrowDown') {
      this.control.setValue(this.autocomplete?._keyManager.activeItem?.value);
    }
  }
  onLostFocus($event: any) {
    if($event.target.value != '') {
      this.option = this.autocomplete?._keyManager.activeItem?.value;
      this.control.setValue(this.autocomplete?._keyManager.activeItem?.value);
    } else {
      this.option = '';
      this.control.setValue(null);
    }
    this.autocompleteTrigger?.closePanel();
  }
  onScroll(data: any) {
    this.autocompleteTrigger?.closePanel();
  }

  private _filter(value: string): Array<IOption> {
    const filterValue = (value && value.toString() != '') ? value.toString().toLowerCase() : '';
    var filteredOptions = this.options.filter(option => option.display.toString().toLowerCase().includes(filterValue));
    return filteredOptions;
  }
}
